<template>
  <div class="form-block form-block--gallery" :class="{'form-block--warning': validationError}">
    <label>{{field.name}}</label>
    <div class="gallery-boxes">
      <div class="gallery-box" v-for="(file,i) of files" :key="i">
        <div class="gallery-box-pic" :style="`background-image:url(${imageUrl}/${file.idFile})`">
          <button class="gallery-box-remove" @click="removeFile(file)"><i class="icon-remove"></i></button>
        </div>
<!--        <span class="attachment-box-name">{{ file.file_name }}</span>-->
<!--        <span class="attachment-box-size">{{ file.file_size }}</span>-->
      </div>

      <div class="gallery-box loading" v-if="uploadingFile">
        <div class="gallery-box-pic">
          <img src="../../assets/images/pic2.svg">
        </div>
        <span class="gallery-box-name">{{ file.file_name }}</span>
        <span class="gallery-box-size">50% uploaded</span>
      </div>
    </div>

    <label for="add-new-gallery" class="button-icon">Upload <i class="icon-upload"></i></label>

    <input type="file" id="add-new-gallery" accept="image/*" name="add-new-attachment" ref="gallery" v-on:change="addFile()" multiple>
    <div class="form-error" v-if="validationError">
      <i class="icon-error"></i> {{field.name}} is required
    </div>
  </div>
</template>

<script>
import api from '@/api/files'
import settings from "@/settings";
//import AttachmentLoader from "./Loader/AttachmentLoader";
export default {
  name: "ImageField",
  props: ['field', 'validationError'],
  //components: {AttachmentLoader},
  data() {
    return {
      uploadingFile: 0,
      files: [],
      imageUrl: `${settings.API_BASE_PATH}/image`
    }
  },
  methods: {
    addFile() {
      Array.from(this.$refs.gallery.files).forEach(file => {
        this.uploadingFile = this.uploadingFile + 1
        api.addFile(file, (data) => {
          this.uploadingFile = this.uploadingFile - 1
          if(data) {
            this.files.push( {
              idFile: data.idFile,
              url: `${this.imageUrl}/${data.idFile}`,
              file_name: data.orgName,
              file_size: data.size,
              file_type: data.type
            })

            this.$emit('changed',  {
              idContentField: this.field.idContentField,
              type:this.field.fieldType,
              files:this.files.map(item => item.idFile),
              multiple: false,
              value:"",
              values: []
            })
          }
        })
      })
    },
    removeFile(file){
      let index = this.files.findIndex((item) => {
        return item.id === file.id
      })
      this.files.splice(index, 1)
    },
    attachmentClassDirectory(type) {
      switch (type) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
          return 'attachment-box--pic'
      }
      return 'attachment-box--default'
    }
  }
}
</script>

<style scoped>

</style>
